const SERVICE_IMAGE_MAX_SIZE = 1200;
const SERVICE_IMAGE_QUALITY = 0.82;

const compressServicePicture = (file) => new Promise((resolve) => {
  if (!file.type.startsWith('image/') || !window.FileReader || !window.File || !window.DataTransfer
      || !HTMLCanvasElement.prototype.toBlob) {
    resolve(file);
    return;
  }

  const reader = new FileReader();
  reader.onload = () => {
    const image = new Image();
    image.onload = () => {
      const scale = Math.min(
        1,
        SERVICE_IMAGE_MAX_SIZE / image.width,
        SERVICE_IMAGE_MAX_SIZE / image.height,
      );
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(image.width * scale);
      canvas.height = Math.round(image.height * scale);
      const context = canvas.getContext('2d');
      if (!context) {
        resolve(file);
        return;
      }
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        if (!blob || blob.size >= file.size) {
          resolve(file);
          return;
        }

        resolve(new File([blob], `${file.name.replace(/\.[^/.]+$/, '')}.jpg`, {
          type: 'image/jpeg',
          lastModified: file.lastModified,
        }));
      }, 'image/jpeg', SERVICE_IMAGE_QUALITY);
    };
    image.onerror = () => resolve(file);
    image.src = reader.result;
  };
  reader.onerror = () => resolve(file);
  reader.readAsDataURL(file);
});

document.addEventListener('turbolinks:load', () => {
  $('#client_client_type').on('change', function (e) {
    if (this.value === 'company_variable' || this.value === 'company_regular') {
      $('#client_business_name').parent().show();
      $('#client_rut').parent().show();
      $('#client_address').parent().show();
      $('#client_billing_contact').parent().show();
      return $('#controls').show();
    } if (this.value === 'person') {
      $('#client_business_name').parent().hide();
      $('#client_rut').parent().hide();
      $('#client_address').parent().hide();
      $('#client_billing_contact').parent().hide();
      return $('#controls').show();
    }
    return $('#controls').hide();
  });

  if ($('#client_client_type').val() === 'company_variable' || $('#client_client_type').val() === 'company_regular') {
    $('#client_business_name').parent().show();
    $('#client_rut').parent().show();
    $('#client_address').parent().show();
    $('#client_billing_contact').parent().show();
    $('#controls').show();
  } else if ($('#client_client_type').val() === 'person') {
    $('#client_business_name').parent().hide();
    $('#client_rut').parent().hide();
    $('#client_address').parent().hide();
    $('#client_billing_contact').parent().hide();
    $('#controls').show();
  } else {
    $('#controls').hide();
  }

  $('#schedule_type').on('change', function (e) {
    if (this.value === 'schedule') {
      $('.schedule').fadeIn();
    } else {
      $('.schedule').fadeOut();
    }
  });

  $('#status').on('change', function (e) {
    if ((route === 0 && $(this).val() === 'done') || $(this).val() === 'returning') {
      $('.aborted-message').fadeOut();
      $('.done-image').fadeIn();
      $('#picture').prop('required', true);
      $('#signature').prop('required', true);
      return;
    }
    if ($(this).val() === 'aborted') {
      $('.aborted-message').fadeIn();
      $('.done-image').fadeIn();
      $('#picture').prop('required', false);
      $('#signature').prop('required', false);
      return;
    }

    $('.aborted-message').fadeOut();
    $('.done-image').fadeOut();
    $('#picture').prop('required', false);
    $('#signature').prop('required', false);
  });

  $('#service_service_type').on('change', function (e) {
    const value = $(this).val();
    const express = $('#quote-express');
    const juniorExpress = $('#quote-junior-express');
    const financial = $('#quote-financial');

    express.hide();
    juniorExpress.hide();
    financial.hide();

    if (value === 'express') {
      express.fadeIn();
      return;
    }

    if (value === 'financial') {
      financial.fadeIn();
      return;
    }

    juniorExpress.fadeIn();
  });

  $('#update-form').on('submit', async function (e) {
    const picture = this.querySelector('#picture');
    if (!picture || !picture.files[0] || !window.DataTransfer) return;

    e.preventDefault();
    $(this).find(':submit').prop('disabled', true);
    const file = await compressServicePicture(picture.files[0]).catch(() => picture.files[0]);
    try {
      const files = new DataTransfer();
      files.items.add(file);
      picture.files = files.files;
    } finally {
      HTMLFormElement.prototype.submit.call(this);
    }
  });
});
